import { render, staticRenderFns } from "./EditPublicationList.vue?vue&type=template&id=1d08fee6"
import script from "./EditPublicationList.vue?vue&type=script&lang=js"
export * from "./EditPublicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports